import React, { PropTypes } from 'react'

import Hero from '../../presentational/Hero';
import omnidermLogo from '../../../images/about/omniderm-logo.jpg';
import hapLogo from '../../../images/hap-logo.jpg';

const HeroContainer = (props) => {
  return (
    <Hero fluid link="about-omniderm">
      <div className="left-center">
        <h1>About Us</h1>
        <img className="omniderm-logo" src={ omnidermLogo } alt="OmniDerm Logo" />
        <img className="hap-logo" src={ hapLogo } alt="Herbal Aktiv Peel Logo" />
      </div>
    </Hero>
  )
}

export default HeroContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/about/HeroContainer.jsx
 **/